/**
 * Gedeelde NL-labels voor het audit-log — gebruikt door de order-tijdlijn
 * (ActivityFeed) én het globale /logboek. Eén bron, zodat een nieuw label niet
 * op één van de twee plekken achterblijft.
 *
 * ACTION_LABELS is een vangnet voor rijen zónder samenvatting (oude rijen en
 * actions zonder template) — schrijvers leggen de leesbare regel zelf vast in
 * `samenvatting`, dus deze map hoeft niet compleet te zijn; onbekende actions
 * tonen de rauwe action-naam.
 */

export const ACTION_LABELS: Record<string, string> = {
  cancel: 'Order geannuleerd',
  appointment_cancel: 'Afspraak geannuleerd',
  add_item: 'Kleed toegevoegd',
  update_item: 'Kleed gewijzigd',
  remove_item: 'Kleed verwijderd',
  bulk_update: 'Meerdere wijzigingen',
  add_upsell: 'Upsell toegevoegd',
  update_notes: 'Opmerkingen bijgewerkt',
  update_fields: 'Ordervelden bijgewerkt',
  update_contact: 'Contactgegevens bijgewerkt',
  address_override: 'Adres aangepast',
  verhuizing: 'Verhuizing verwerkt',
  datum_window: 'Datumvenster aangepast',
  order_discount: 'Korting aangepast',
  order_refund: 'Refund uitgevoerd',
  order_mark_picked_up: 'Gemarkeerd als opgehaald',
  order_self_service_complete: 'Zelfservice geregistreerd (gebracht/opgehaald)',
  order_mollie_sync: 'Mollie-sync uitgevoerd',
  invoice_create_from_werkorder: 'Factuur aangemaakt',
  invoice_credit: 'Creditfactuur aangemaakt',
  klacht_register: 'Klacht geregistreerd',
  klacht_close: 'Klacht gesloten',
  send_email: 'Statusmail verstuurd',
  transactie_create: 'Betaling geregistreerd',
  sf_proxy_call: 'Salesforce-call via proxy',
  client_afspraak: 'Afspraak gekozen',
  client_wijzig_afspraak: 'Afspraak gewijzigd',
  client_update_adres: 'Adres gewijzigd',
  client_annuleer: 'Order geannuleerd',
  client_reactiveer: 'Order gereactiveerd',
  abonnement_order_aangemaakt: 'Abonnementsorder aangemaakt',
};

/** Kanaal-badge: alleen tonen als het NIET een office-medewerker was. */
export const CHANNEL_BADGES: Record<string, { label: string; className: string }> = {
  'client-app': { label: 'klant', className: 'bg-sky-50 text-sky-700' },
  'voice-agent': { label: 'voice-agent', className: 'bg-violet-50 text-violet-700' },
  'field-app': { label: 'field-app', className: 'bg-emerald-50 text-emerald-700' },
  brein: { label: 'brein', className: 'bg-indigo-50 text-indigo-700' },
  systeem: { label: 'systeem', className: 'bg-slate-100 text-slate-600' },
};

export const KANALEN = ['office-app', 'client-app', 'voice-agent', 'field-app', 'brein', 'systeem'] as const;

function firstName(email: string): string {
  const name = email.split('@')[0] ?? email;
  return name.split(/[._-]/)[0] ?? name;
}

/** "Wie" op de regel: bij een agent-kanaal is de actor-email geen mailadres. */
export function actorLabel(entry: { channel: string; actorEmail: string; onBehalfOf: string | null }): string {
  if (entry.channel === 'voice-agent') {
    return entry.onBehalfOf ? `Voice-agent namens ${entry.onBehalfOf}` : 'Voice-agent';
  }
  if (entry.channel === 'client-app') return 'Klant';
  if (entry.channel === 'brein') return 'Brein';
  if (entry.channel === 'systeem') return 'Systeem';
  return firstName(entry.actorEmail);
}
